export const BETTER_DECISIONS_GUIDE = {
  path: "/better-decisions",
  url: "https://ahavibes.xyz/better-decisions",
  headline: "Better Decisions: Turning Clarity Into Confident Action",
  description:
    "Reduce decision fatigue, separate assumptions from facts, catch cognitive bias, and choose responses with a clear process under pressure.",
  sections: [
    {
      id: "decision-fatigue",
      position: 1,
      name: "Decision Fatigue",
      description:
        "Why decision quality drops after a long day of choosing — and how to protect the Interpretation step.",
    },
    {
      id: "decision-confidence",
      position: 2,
      name: "Decision Confidence",
      description:
        "How to commit without waiting for certainty, by trusting a process instead of a feeling.",
    },
    {
      id: "cognitive-biases",
      position: 3,
      name: "Cognitive Biases",
      description:
        "The mental shortcuts that distort Interpretation — and how to notice them before you respond.",
    },
    {
      id: "assumptions-vs-facts",
      position: 4,
      name: "Assumptions vs Facts",
      description:
        "How to separate what happened from the story you added — the core of clearer decisions.",
    },
    {
      id: "clear-decision-making",
      position: 5,
      name: "Clear Decision Making",
      description:
        "A repeatable EIER sequence for foggy moments when options feel crowded and urgent.",
    },
    {
      id: "difficult-conversations",
      position: 6,
      name: "Difficult Conversations",
      description:
        "Prepare what you will say by separating Event, Interpretation, Evidence, and Response.",
    },
    {
      id: "leadership-decisions",
      position: 7,
      name: "Leadership Decisions",
      description:
        "How visibility and precedent change the weight of a choice — and how to decide under watching eyes.",
    },
    {
      id: "reflection-before-action",
      position: 8,
      name: "Reflection Before Action",
      description:
        "Protect the short gap between what happened and what you do next.",
    },
  ],
};
